import { PriceDisplay } from '@/components/blocks/PriceDisplay';
import { TransactionError } from '@/data/types/Basic';
import { Stack, Typography } from '@mui/material';

interface Props {
	errorData: TransactionError;
	currency?: string;
}

export const ErrorScenery: React.FC<Props> = ({ errorData, currency }) => (
	<Stack mt={'12px'}>
		<Stack direction={'row'}>
			{errorData && errorData.errorKey === 'ERR_MAX_DPVALE_AMOUNT' ? (
				<Typography
					component={'span'}
					sx={{ fontSize: 'var(--font-size-small)', fontWeight: 'normal' }}
				>
					{'El total de tu orden supera el monto máximo de '}
					<Typography
						component={'span'}
						sx={{ fontSize: 'var(--font-size-small)', fontWeight: 'bold' }}
					>
						<PriceDisplay currency={currency} min={Number(errorData.errorParameters[1])} />
						{' pesos'}
					</Typography>
					{
						' que se tiene autorizado para pagar con dpvale, revisa con tu distribuidor tu importe máximo autorizado de compra.'
					}
				</Typography>
			) : null}
		</Stack>
	</Stack>
);
